import { render, staticRenderFns } from "./SubscriptionItemView.vue?vue&type=template&id=d961bc20&scoped=true&"
import script from "./SubscriptionItemView.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionItemView.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionItemView.vue?vue&type=style&index=0&id=d961bc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d961bc20",
  null
  
)

export default component.exports